import { Heading } from "@trueskin-web/components"

import Accordion from "../../../components/choose-plan/components/accordion"

const FAQs = ({ title, items, children }) =>
  !!items?.length ? (
    <div
      sx={{
        width: ["100vw", "100%"],
        position: "relative",
        left: ["50%", 0],
        mr: [null, "auto"],
        ml: ["-50vw", 0],
        overflow: "hidden",
        bg: "#FFFFFF",
        borderRadius: "32px",
        p: "24px",
      }}
    >
      {!!title && (
        <Heading
          as="h3"
          mb={4}
          sx={{
            lineHeight: "body",
            fontWeight: "bold",
          }}
        >
          {title}
        </Heading>
      )}
      {children}
      {items.map(({ icon, question, answer }, index) => (
        <Accordion key={index} icon={icon} title={question}>
          {answer}
        </Accordion>
      ))}
    </div>
  ) : null

export default FAQs
